(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const main = gallery.querySelector('[data-gallery-main]');
      gallery.querySelectorAll('.thumb').forEach(button => button.addEventListener('click', () => {
        main.src = button.dataset.image;
        main.alt = button.dataset.alt;
        gallery.querySelectorAll('.thumb').forEach(item => {
          item.classList.toggle('active', item === button);
          item.setAttribute('aria-pressed', String(item === button));
        });
        gallery.querySelector('[data-gallery-status]').textContent = button.dataset.alt;
      }));
    });
    root.querySelectorAll('[data-product-section]').forEach(section => {
      const select = section.querySelector('[data-variant-select]');
      if (!select || select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        section.querySelector('[data-product-price]').textContent = option.dataset.price;
        const compare = section.querySelector('[data-compare-price]');
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
        const add = section.querySelector('[data-add-button]');
        add.disabled = option.dataset.available !== 'true';
        add.textContent = add.disabled ? 'Sold out' : 'Add to bag';
        if (option.dataset.image) {
          section.querySelector('[data-gallery-main]').src = option.dataset.image;
          section.querySelectorAll('.thumb').forEach(item => {
            const selected = item.dataset.image === option.dataset.image;
            item.classList.toggle('active', selected);
            item.setAttribute('aria-pressed', String(selected));
          });
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
